module.exports = __webpack_public_path__ + "img/Vector_10.faa5d0e3.svg";